import { useGetQuery } from 'shared/lib/api';

import type { OnboardingModel } from '../model';

import { onboardingRoutes } from './routes';

export function useGetOnboardingStatus(enabled?: boolean) {
  return useGetQuery<OnboardingModel>(onboardingRoutes.app.getOnboardingStatus, {
    enabled,
  });
}
